// extracted by mini-css-extract-plugin
export default {"logoWrapper":"GAvPglIciNZZ5s-mhlqvIg=="};